// PasswortRegeln.jsx — die eine Passwortregel als Liste zum Abhaken (25.10.2026)
//
// Regeln aus lib/passwortRegel.js (Abschrift von backend/utils/passwortRegel.js),
// jede Zeile wird grün, sobald sie erfüllt ist. Steht unter jedem Feld, in dem
// ein Mensch ein Passwort wählt: Registrierung, Zurücksetzen, Personal-Zugang,
// Athletenkonto. Farben mit Rückfall, damit die Liste auf den öffentlichen
// Seiten (.au) wie auf der Anmeldeseite (.anm-) lesbar ist.
import React from 'react';
import { PASSWORT_REGELN } from '../../lib/passwortRegel';
import './PasswortRegeln.css';

export default function PasswortRegeln({ passwort, id, gezeigt = true }) {
  if (!gezeigt) return null;
  const pw = typeof passwort === 'string' ? passwort : '';
  return (
    <ul className="pwr" id={id} aria-label="Anforderungen an das Passwort">
      {PASSWORT_REGELN.map((r) => {
        const ok = r.test(pw);
        return (
          <li key={r.id} className={ok ? 'pwr-ok' : ''} data-regel={r.id} data-erfuellt={ok ? '1' : '0'}>
            <span className="pwr-zeichen" aria-hidden="true">{ok ? '✓' : ''}</span>
            <span>{r.text}</span>
            <span className="pwr-sr">{ok ? ' (erfüllt)' : ' (fehlt noch)'}</span>
          </li>
        );
      })}
    </ul>
  );
}
